import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router-dom";
import TkStepper from "../../components/atoms/TkStepper";
import { Box } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import { httpAPI_CON003 } from "./api/request";
import { funBodyList } from "./hooks/useHooks";
import { stepperData } from "../SCRC070003/parts";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkTitle from "../../components/atoms/TkTitle";
import { Status } from "../../assets/data/Constants";
import StaffListTable from "./components/components";

/**
 * SCRC070003 申請情報詳細（職員情報）一覧
 * @returns 申請情報詳細（職員情報）一覧
 */
const SCRC070003 = () => {
  const navigate = useNavigate();

  const { state: businessState } = useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const [step, setStep] = useState(0);

  // 初期表示
  const handleInit = async () => {
    // 申請職員名簿一覧参照API 呼び出し
    try {
      const res = await httpAPI_CON003({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        applyId: businessState.job_23?.applyId,
        facilityNo: businessState.job_23?.registrationProcedureInfo?.facilityNo,
      });

      if (res.resultCd === "I0000") {
        const completeMap = [
          Status["通知待ち"],
          Status["通知拒絶待ち"],
          Status["郵送待ち"],
          Status["郵送拒絶待ち"],
          Status["処理完了"],
          Status["処理拒絶完了"],
          Status["取下済"],
        ];
        setStep(completeMap.includes(res.latestApplyStatus as Status) ? 2 : 1);

        setBodyList(funBodyList(res.staffList!));

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC070003" data-testid="SCRC070003PageForTest">
      <TkStepper steps={stepperData} activeStep={step}></TkStepper>

      <Box className="info">
        <TkTitle size="medium">
          {(businessState.job_23?.registrationProcedureInfo?.facilityNo ?? "") +
            ":" +
            (businessState.job_23?.registrationProcedureInfo?.facilityName ?? "") +
            "　施設種類 " +
            (businessState.job_23?.registrationProcedureInfo?.facilityKind ?? "")}
        </TkTitle>

        <StaffListTable bodyList={bodyList} />
      </Box>
      <Box className="button">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC070003;
